import { FlexContainer } from '@act/storybook';
import { Typography } from '@mui/material';

/**
 * Shown until the acting guide has answered on their phone.
 *
 * @returns Waiting state message.
 */
export const ActiveCallMenuWaitingPanel = () => (
  <FlexContainer
    direction="column"
    padding={3}
    backgroundColor="white"
    borderRadius="moreRounded"
    alignItems="center"
    overflow="visible"
    overflowAllVisible
    height="auto"
  >
    <Typography variant="bodyMedium" color="text.secondary" fontStyle="italic">
      Answer the call on your phone to display full call controls
    </Typography>
  </FlexContainer>
);
